import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import {
  Location as LocationIcon,
  MagnifyingGlass as MagnifyingGlassIcon,
} from '@common/components/Icons';
import { BUTTON_VARIANTS } from '@common/components/Button';

import {
  Wrapper,
  InputGroup,
  NearMeButton,
  SearchButton,
  Input,
} from './SearchInput.styled';

const SearchInput = ({
  query,
  onQueryChange,
  onNearMeClick,
  isLocationSearchDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <InputGroup>
        <Input
          value={query}
          onChange={onQueryChange}
          placeholder={t(
            'storefinder.otherStores.input.placeholder',
            'PLZ oder Ort',
          )}
        />
        <SearchButton
          type="button"
          iconRight={<MagnifyingGlassIcon />}
          buttonId="availability-search-button"
        />
      </InputGroup>

      <NearMeButton
        variant={BUTTON_VARIANTS.LEVEL_1_GREEN}
        type="button"
        onClick={onNearMeClick}
        iconRight={<LocationIcon />}
        data-testid="near-me-button"
        buttonId="availability-near-me-button"
        disabled={isLocationSearchDisabled}
      >
        {t('storefinder.otherStores.nearMe', 'In meiner Nähe')}
      </NearMeButton>
    </Wrapper>
  );
};

SearchInput.propTypes = {
  query: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onNearMeClick: PropTypes.func.isRequired,
  isLocationSearchDisabled: PropTypes.bool.isRequired,
};

export default SearchInput;
